import { AUTH_API, handleApiError } from '../../utils/axios';

export const getMyEvents = async (date) => {
  try {
    const { data } = await AUTH_API.get(`/api/v1/events?date=${date}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const createEvent = async (event) => {
  try {
    const { data } = await AUTH_API.post(`/api/v1/events`, event);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const updateEvent = async (eventId, event) => {
  try {
    const { data } = await AUTH_API.put(`/api/v1/events/${eventId}`, event);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};

export const deleteEvent = async (eventId) => {
  try {
    const { data } = await AUTH_API.delete(`/api/v1/events/${eventId}`);
    return { error: null, data };
  } catch (error) {
    return handleApiError(error);
  }
};
